'use strict';

const isMobileDevice = require('./isMobileDevice');
const isTabletDevice = require('./isTabletDevice');

/**
 * Set element height with JavaScript - usefull for touch devices what have problems with CSS vh units.
 *
 * @input
 * ele 		: HTML Dom Element to resize
 * param1 	: Optional parameter for setting the height in %, if not set default is used. (default:100%)
 *
 * TODO:
 *  - make @input ele accept also objects and arrays
 */
const setViewportHeight = (ele, param1, forceDesktop) => {
    forceDesktop = typeof forceDesktop !== 'undefined' ? forceDesktop : false;
    let viewportHeight = $(window).height();

    // only MOBILE and TABLET
    if (isMobileDevice() || isTabletDevice() || forceDesktop) {

        // Listen for resize changes
        $(window).resize(function() {
            viewportHeight = $(window).height();

            $(ele).css({
                height: param1 ? (viewportHeight / 100) * param1 + 'px' : viewportHeight + 'px'
            });

        });

        // Listen for orientation changes
        window.addEventListener('orientationchange', function() {
            viewportHeight = $(window).height();
            // Announce the new orientation number
            $(ele).css({
                height: param1 ? (viewportHeight / 100) * param1 + 'px' : viewportHeight + 'px'
            });

        }, false);
    }
};

module.exports = setViewportHeight;
